/* eslint-disable no-undef */
import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { register } from '../../../i18n';
import { Accommodations } from '../../../Constants';
import WebReaderService from '../../services/WebReaderService';

const t = register('ToolNames');

const TextToSpeechControls = observer((props) => {
  const {
    publisherManager,
    toolbarManager
  } = useContext(MobXProviderContext);

  const { showWebReader } = toolbarManager;

  const excludeTranslation = !toolbarManager.contentToolAvailability.includes('Translate') ||
    toolbarManager.userAccommodationsOff.includes(Accommodations.ASSESSMENT_TRANSLATION) ||
    toolbarManager.activityAccommodationsOff.includes(Accommodations.LESSON_TRANSLATION);

  const excludeDictionary = !toolbarManager.contentToolAvailability.includes('Dictionary') ||
    toolbarManager.userAccommodationsOff.includes(Accommodations.LESSON_DICTIONARY) ||
    toolbarManager.activityAccommodationsOff.includes(Accommodations.LESSON_DICTIONARY);

  const excludeListen = !toolbarManager.contentToolAvailability.includes('TextHelp') ||
    toolbarManager.userAccommodationsOff.includes(Accommodations.ASSESSMENT_TEXT_SPEECH) ||
    toolbarManager.userAccommodationsOff.includes(Accommodations.LESSON_TEXT_SPEECH) ||
    toolbarManager.activityAccommodationsOff.includes(Accommodations.LESSON_TEXT_SPEECH);
  console.log('excludeListen', excludeListen);
  // const excludeTranslation = false;
  // const excludeDictionary = false;
  // const excludeListen = true;

  useEffect(() => {
    const webreader = document.getElementById('webreader_script');
    // Add ReadSpeaker script if we don't have it when component mounts.
    if (!webreader) {
      const customerId = publisherManager.webReaderId ? String(publisherManager.webReaderId) : undefined;
      // Language only — voice comes from ReadSpeaker account configuration
      const localeId = document.documentElement.lang || 'en';
      const rsLang = WebReaderService.normalizeLanguageCode(localeId) || 'en_us';
      window.rsConf = {
        general: {
          usePost: true,
          customerid: customerId,
          lang: rsLang
        },
        settings: { hlicon: 'iconon' },
        ui: {
          tools: {
            translation: !excludeTranslation,
            dictionary: !excludeDictionary
          }
        }
      };
      const scriptRs = document.createElement('script');
      scriptRs.src = `https://cdn-na.readspeaker.com/script/${publisherManager.webReaderId}/webReader/webReader.js?pids=wr`;
      scriptRs.async = true;
      scriptRs.id = 'webreader_script';
      // Initialize WebReaderService once the script loads so it's ready for
      // translate/dictionary calls (registers the rsapiReady event listener)
      scriptRs.onload = () => WebReaderService.init();
      document.body.appendChild(scriptRs);
    }
    // When showWebReader toggles on, add the toggler button
    if (webreader && showWebReader) {
      rspkr.tools.toggler.add();
    }
  }, [showWebReader, excludeTranslation, excludeDictionary, excludeListen]);

  return (
    <>
      {/* Suppress RS context menu on text selection - we use our own toolbar
          buttons for translate/dictionary to avoid conflicts with other
          highlight-based tools and our custom language selector */}
      <style>{'.rspopup, .rs-contextmenu, #rsbtn_popup { display: none !important; }'}</style>
      {(publisherManager.hasWebReaderId && publisherManager.rsHref) && (
        <div
          className='rs_skip rsbtn rs_preserve'
          id='readspeaker_button1'
          style={showWebReader && !excludeListen
            ? {}
            : { visibility: 'hidden', position: 'absolute', width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' }}
        >
          {/* eslint-disable-next-line jsx-a11y/no-access-key */}
          <a accessKey='L' className='rsbtn_play' href={publisherManager.rsHref} rel='nofollow noopenner'
            title='Listen to this page using ReadSpeaker webReader'>
            <span className='rsbtn_left rsimg rspart'>
              <span className='rsbtn_text'>
                <span>{t('textToSpeachInfo')}</span>
              </span>
            </span>
            <span className='rsbtn_right rsimg rsplay rspart' />
          </a>
        </div>
      )}
    </>
  );
});
export default TextToSpeechControls;
